<template>
  <div>
    <v-container
      fluid
      class="pt-2"
      :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
    >
      <v-layout>
        <v-flex xs6 sm3>
          <v-card class="pa-2">
            <v-list three-line dense class="transparent">
              <template v-for="(business, index) in businesses">
                <v-list-item :key="`list-${business.id}`">
                  <v-list-item-content>
                    <v-list-item-title>{{ business.name }}</v-list-item-title>
                    <v-list-item-subtitle class="text--primary" v-if="business.type">
                      <strong>Business Type: </strong>{{ startCase(business.type.name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index !== businesses.length - 1" :key="`divider-${business.id}`"></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card class="ml-2">
            <v-toolbar flat color="white" class="pl-3">
              <v-toolbar-title>Add New Business</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-form>
                  <v-layout wrap>
                    <v-flex xs9>
                      <v-select
                        :items="selectableBusinessTypes"
                        item-text="name"
                        v-model="newBusiness.business_type"
                        label="Select a business type"
                        flat
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn
                        class="float-right"
                        color="accent"
                        :disabled="newBusiness.business_type.id === null"
                        @click.stop="showNewBusiness"
                        >Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <new-bank :show.sync="showNewBank" :account="SelectedAccount"></new-bank>
    <new-broker :show.sync="showNewBroker" :account="SelectedAccount"></new-broker>
    <new-property-broker :show.sync="showNewPropertyBroker" :account="SelectedAccount"></new-property-broker>
    <new-partner :show.sync="showNewPartner" :account="SelectedAccount"></new-partner>
    <new-funder :show.sync="showNewFunder" :account="SelectedAccount"></new-funder>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import NewBank from './NewBusinessDialogs/NewBank';
import NewBroker from './NewBusinessDialogs/NewBroker';
import NewPropertyBroker from './NewBusinessDialogs/NewPropertyBroker';
import NewPartner from './NewBusinessDialogs/NewPartner';
import NewFunder from './NewBusinessDialogs/NewFunder';

export default {
  components: {
    NewBank,
    NewBroker,
    NewPropertyBroker,
    NewPartner,
    NewFunder
  },
  name: 'account-businesses',
  data: () => ({
    showNewBank: false,
    showNewBroker: false,
    showNewPropertyBroker: false,
    showNewPartner: false,
    showNewFunder: false,
    businesses: [],
    newBusiness: {
      name: null,
      business_type: {
        id: null,
        name: null
      }
    },
    excludeTypes: ['customer', 'platform', 'referrer', 'sub_partner']
  }),
  computed: {
    ...mapGetters(['SelectedAccount', 'BusinessTypes', 'UILeftDrawer', 'PlatformBusiness', 'BusinessHasRole']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    selectableBusinessTypes: function() {
      return _.map(
        _.filter(this.BusinessTypes, businessType => !_.includes(this.excludeTypes, businessType.name)),
        function(type) {
          return { name: _.startCase(type.name), value: type.name };
        },
        this
      );
    }
  },
  methods: {
    ...mapActions(['updateAccountBusiness', 'sendWelcomeMessage']),
    startCase: function(str) {
      str = _.lowerCase(str);
      return _.startCase(str);
    },
    showNewBusiness() {
      switch (this.newBusiness.business_type) {
        case 'bank':
          this.showNewBank = true;
          break;
        case 'broker':
          this.showNewBroker = true;
          break;
        case 'property_broker':
          this.showNewPropertyBroker = true;
          break;
        case 'partner':
          this.showNewPartner = true;
          break;
        case 'provider':
          this.showNewFunder = true;
          break;
      }
    }
  },
  mounted() {
    this.businesses = this.SelectedAccount.businesses;
  },
  watch: {
    SelectedAccount: function() {
      this.businesses = this.SelectedAccount.businesses;
    }
  }
};
</script>

<style lang="scss" scoped>
.calc-height {
  height: calc(100vh);
  max-height: calc(100vh);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-filtered-height {
  height: calc(100vh - 267px);
  max-height: calc(100vh - 267px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
</style>
